/* eslint-disable */
export default {
  unknown: '알 수 없음',
  anonymous: '익명',
  activeCall: '활성 통화',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
